import React, { useRef, useEffect } from 'react'
import { ParagraphComp } from '../../../Components/ParagraphComp/ParagraphComp'
import { InputCompo } from '../../../Components/InputCompo/InputCompo'
import ArrowDropDownCircleIcon from '@mui/icons-material/ArrowDropDownCircle';
import { useNavigate } from 'react-router-dom';
const MakeADifference = ({ values, setFieldValue, setAdvPostData, tabs, setTabs }) => {
    const checkboxList = [
        { name: 'give_money', label: 'Give Money' },
        { name: 'gift_in_kind', label: 'Gift in Kind' },
        { name: 'volunteer', label: 'Volunteer' },
        { name: 'purchase_products', label: 'Purchase Products of NPOs' },
        { name: 'celebrate', label: 'Celebrate (Occasions, Events and Visits)' },
        { name: 'participate_in', label: 'Participate in/ Support Campaigns' },
    ]
    const navigate = useNavigate()
    const searchParams = new URLSearchParams(window.location.search);
    const advancedSearchMiniTab = searchParams.get('advancedSearchMiniTab');
    const miniTab = JSON.parse(decodeURIComponent(advancedSearchMiniTab))

    const viewTabs = (name) => {
        if (miniTab?.[name]) {
            navigate(`/search?advancedSearchMiniTab=${encodeURIComponent(JSON.stringify({ ...tabs, [name]: false }))}`, { replace: true });
        } else {
            navigate(`/search?advancedSearchMiniTab=${encodeURIComponent(JSON.stringify({ ...tabs, [name]: true }))}`, { replace: true });
        }
    }

    useEffect(() => {
        if (advancedSearchMiniTab) {
            setTabs(miniTab)
        }
    }, [advancedSearchMiniTab])


    return (
        <>

            <div className='p-[10px] rounded-xl mt-[20px] bg-[white]'>
                <div className='flex justify-between items-center'>
                    <ParagraphComp text='Choose to to make a difference' className='text-[#004878]' />
                    <div className='cursor-pointer' onClick={() => viewTabs('Choose to to make a difference')}>
                        <ArrowDropDownCircleIcon className='text-[30px] text-[#004878]' />
                    </div>
                </div>
                {/* {tabs?.["Choose to to make a difference"] && */}
                <div className="w-[100%]">
                    {checkboxList.map((ele) => {
                        const fieldName = ele.name
                        return (
                            <label
                                className="flex mt-[16px] items-center space-x-2"
                                key={fieldName}
                            >
                                <InputCompo
                                    onChange={() =>
                                        setFieldValue(fieldName, !values[fieldName])
                                    }
                                    checked={!!values[fieldName]} // Ensure checkbox state is in sync
                                    name={fieldName}
                                    className="bg-[#004878] text-white w-[20px] h-[20px]"
                                    type="checkbox"
                                />
                                <span className="text-black">{ele?.label}</span>
                            </label>
                        );
                    })}
                </div>
                {/* } */}
            </div>
        </>
    )
}

export default MakeADifference